import React from 'react';

const Caption = (props) => (
    <figcaption className={`caption has-text-centered ${props.className}`} style={props.style}>
        {props.children}
    </figcaption>
)

export default Caption;